import type { Locale } from './types'

export const LOCALE_STORAGE_KEY = 'openclaw.locale'

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'en' || value === 'de'
}

export function detectLocaleFromLanguages(languages: readonly string[] = []): Locale {
  return languages.some((lang) => lang.toLowerCase().startsWith('de')) ? 'de' : 'en'
}

export function detectInitialLocale(): Locale {
  if (typeof window === 'undefined') return 'en'

  const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY)
  if (isLocale(stored)) return stored

  const languages = [
    ...(window.navigator.languages ?? []),
    window.navigator.language,
  ].filter(Boolean)

  return detectLocaleFromLanguages(languages)
}

export function persistLocale(locale: Locale) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(LOCALE_STORAGE_KEY, locale)
}
